(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aim-origin-memoir"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aim-origin')) {
    customElements.define('aim-origin', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const video = this.querySelector('video');
        const toggle = this.querySelector('[data-origin-toggle]');
        if (!video || !toggle) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let manualPause = false;
        let visible = true;
        const sync = () => {
          toggle.classList.toggle('is-paused', video.paused);
          toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        const update = () => {
          video.autoplay = !reduced.matches;
          if (!visible || document.hidden || manualPause || reduced.matches) video.pause();
          else video.play().catch(sync);
        };
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          if (video.paused) {
            manualPause = false;
            video.play().catch(sync);
          } else {
            manualPause = true;
            video.pause();
          }
        }, { signal });
        video.addEventListener('play', sync, { signal });
        video.addEventListener('pause', sync, { signal });
        video.addEventListener('loadeddata', update, { signal });
        document.addEventListener('visibilitychange', update, { signal });
        reduced.addEventListener('change', update, { signal });
        this.observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          update();
        }, { threshold: .1 });
        this.observer.observe(video);
        update();
        sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-story-cinema"] && !Shopify.designMode) return;
  try {
    
  if (document.body.classList.contains('template-page-our-story')) {
    document.addEventListener('keyup', event => {
      if (event.key !== 'Escape') return;
      const menu = document.querySelector('.mobile-toggle-wrapper[open].active');
      if (menu) menu.querySelector('.mobile-toggle')?.click();
    }, true);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-story-seen', '');
            observer.unobserve(entry.target);
          }
        }
      }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      document.querySelectorAll('.aim-story__copy, .aim-story--reading .aim-story__reading, .aim-story__pair figure, .aim-story--pair .aim-story__reading, .aim-story__closing').forEach(element => {
        element.classList.add('story-reveal');
        observer.observe(element);
      });
    }
  }
  if (!customElements.get('aim-story-gallery')) {
    customElements.define('aim-story-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.items = Array.from(this.querySelectorAll('[data-story-art]'));
        this.rail = this.querySelector('.aim-story__gallery');
        if (!this.rail || !this.items.length) return;
        this.railPrevious = this.querySelector('[data-story-rail-prev]');
        this.railNext = this.querySelector('[data-story-rail-next]');
        this.railCount = this.querySelector('[data-story-rail-count]');
        this.updateRail = () => {
          const step = this.items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
          const index = Math.max(0, Math.min(this.items.length - 1, Math.round(this.rail.scrollLeft / step)));
          this.railCount.textContent = String(index + 1).padStart(2, '0') + ' / ' + this.items.length;
          this.railPrevious.disabled = this.rail.scrollLeft < 2;
          this.railNext.disabled = this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 2;
        };
        this.moveRail = direction => {
          const step = this.items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
          this.rail.scrollBy({ left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.railPrevious.addEventListener('click', () => this.moveRail(-1));
        this.railNext.addEventListener('click', () => this.moveRail(1));
        this.rail.addEventListener('scroll', () => {
          if (this.railFrame) return;
          this.railFrame = requestAnimationFrame(() => {
            this.railFrame = null;
            this.updateRail();
          });
        }, { passive: true });
        this.railResize = new ResizeObserver(this.updateRail);
        this.railResize.observe(this.rail);
        this.updateRail();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.picture = document.createElement('img');
        this.picture.alt = '';
        this.querySelector('.aim-story__viewer-image').append(this.picture);
        this.previous = this.querySelector('[data-story-prev]');
        this.next = this.querySelector('[data-story-next]');
        this.count = this.querySelector('[data-story-count]');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-story-art]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.origin = link;
          this.show(this.items.indexOf(link));
          this.dialog.showModal();
        });
        this.previous.addEventListener('click', () => this.show(this.index - 1));
        this.next.addEventListener('click', () => this.show(this.index + 1));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.origin?.focus({ preventScroll: true }));
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.railResize?.disconnect();
        if (this.railFrame) cancelAnimationFrame(this.railFrame);
      }
      show(index) {
        if (index < 0 || index >= this.items.length) return;
        this.index = index;
        this.picture.src = this.items[index].href;
        this.picture.alt = this.items[index].querySelector('img').alt;
        this.count.textContent = `${index + 1} / ${this.items.length}`;
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.items.length - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aimanimation-cinema"] && !Shopify.designMode) return;
  try {
    
function initAIMAnimation(){
document.querySelectorAll('.an-cinema video.an-motion').forEach(video=>{
if(video.dataset.anReady)return;video.dataset.anReady='true';
video.muted=true;video.playsInline=true;video.loop=true;
let visible=false,userPaused=false,autoPause=false;
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
video.autoplay=!reduced.matches;
const toggle=video.closest('.an-cinema').querySelector('.an-toggle');
const sync=()=>{if(toggle){toggle.textContent=video.paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(!video.paused));}};
const pause=()=>{if(!video.paused){autoPause=true;video.pause();}};
const play=()=>{if(visible&&!document.hidden&&!reduced.matches&&!userPaused)video.play().catch(()=>{});};
video.addEventListener('loadeddata',play);
video.addEventListener('pause',()=>{if(autoPause)autoPause=false;else if(visible&&!document.hidden)userPaused=true;sync();});
video.addEventListener('play',()=>{userPaused=false;if(!visible||document.hidden)pause();sync();});
if(toggle)toggle.addEventListener('click',()=>{if(video.paused){userPaused=false;video.play().catch(()=>{});}else{userPaused=true;video.pause();}sync();});
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)play();else pause();},{threshold:.2});observer.observe(video);
document.addEventListener('visibilitychange',()=>{if(document.hidden)pause();else play();});
reduced.addEventListener('change',()=>{video.autoplay=!reduced.matches;if(reduced.matches)pause();else play();});
sync();
});
}
initAIMAnimation();document.addEventListener('shopify:section:load',initAIMAnimation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aimcomics-chapter"] && !Shopify.designMode) return;
  try {
    
function initAIMComicsFilms() {
  document.querySelectorAll('.au-chapter video.au-video').forEach(video => {
    if (video.dataset.autoplayReady) return;
    video.dataset.autoplayReady = 'true';
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    let visible = false;
    let userPaused = false;
    let automaticPause = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    video.autoplay = !reduced.matches;
    const pause = () => {
      if (!video.paused) {
        automaticPause = true;
        video.pause();
      }
    };
    const play = () => {
      if (visible && !document.hidden && !reduced.matches && !userPaused) {
        video.play().catch(() => {});
      }
    };
    video.addEventListener('loadeddata', play);
    video.addEventListener('pause', () => {
      if (automaticPause) automaticPause = false;
      else if (visible && !document.hidden) userPaused = true;
    });
    video.addEventListener('play', () => {
      userPaused = false;
      if (!visible || document.hidden) pause();
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) play();
      else pause();
    }, { threshold: 0.25 });
    observer.observe(video);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else play();
    });
    reduced.addEventListener('change', () => {
      video.autoplay = !reduced.matches;
      if (reduced.matches) pause();
      else play();
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(video)) observer.disconnect();
    });
  });
}
initAIMComicsFilms();
document.addEventListener('shopify:section:load', initAIMComicsFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aimcomics-opening"] && !Shopify.designMode) return;
  try {
    
function setupAIMComics(){document.querySelectorAll('.ac-opening').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const video=section.querySelector('video'),button=section.querySelector('.ac-motion');if(!video){button.hidden=true;return}const sync=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause};video.addEventListener('play',sync);video.addEventListener('pause',sync);if(matchMedia('(prefers-reduced-motion: reduce)').matches){video.pause();video.autoplay=false}button.addEventListener('click',()=>{video.style.visibility='visible';if(video.paused){video.play().catch(sync)}else{video.pause()}});sync();const philosophy=document.querySelector('[id$="__layered_images_with_text_X3Rr9P"]');const link=section.querySelector('a[href="#ac-philosophy"]');if(philosophy&&link)link.href='#'+philosophy.id})}setupAIMComics();document.addEventListener('shopify:section:load',setupAIMComics);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aimtv-cinematic"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.getElementById('aimtv-cinema');if(!root||root.dataset.ready)return;root.dataset.ready='true';const ambient=root.querySelector('#aimtv-ambient'),motion=root.querySelector('#aimtv-motion'),film=root.querySelector('#aimtv-film'),player=film.querySelector('video');
function setMotion(){motion.textContent=ambient.paused?'▷ Motion':'Ⅱ Pause';motion.setAttribute('aria-label',ambient.paused?'Play background video':'Pause background video')}
ambient.addEventListener('play',setMotion);ambient.addEventListener('pause',setMotion);motion.addEventListener('click',()=>{if(ambient.paused)ambient.play().catch(()=>{motion.textContent='Video unavailable'});else ambient.pause()});
root.querySelector('#aimtv-watch').addEventListener('click',()=>{ambient.pause();film.showModal();player.play().catch(()=>{})});
root.querySelector('#aimtv-close').addEventListener('click',()=>film.close());film.addEventListener('close',()=>player.pause());film.addEventListener('click',e=>{if(e.target===film){const r=film.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)film.close()}});player.addEventListener('error',()=>root.querySelector('#aimtv-video-error').hidden=false);
const rail=root.querySelector('#aimtv-rail'),prev=root.querySelector('#aimtv-prev'),next=root.querySelector('#aimtv-next');const reduced=matchMedia('(prefers-reduced-motion: reduce)');ambient.muted=true;if(reduced.matches){ambient.autoplay=false;ambient.pause();}else{ambient.play().catch(()=>setMotion());}setMotion();function updateRail(){prev.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2}prev.addEventListener('click',()=>rail.scrollBy({left:-460,behavior:reduced.matches?'instant':'smooth'}));next.addEventListener('click',()=>rail.scrollBy({left:460,behavior:reduced.matches?'instant':'smooth'}));rail.addEventListener('scroll',updateRail);window.addEventListener('resize',updateRail);updateRail();
})();

  } catch(e) { console.error(e); }
})();
})();
